<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form class="demo-form-inline" size="small" ref="form" :model="form" label-width="90px">
        <el-row>
          <el-col span="6">
          <el-form-item label="小区分组" prop="communityGroup">
            
            <el-select style="width: 100%" v-model="form.communityGroup" @change="communityGroupChangeHandler">
              <el-option
                v-for="item in communityGroupList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="小区名称"
              prop="communityId"
              :rules="[{ required: true, message: '请选择小区', trigger: 'blur' }]"
            >
            
                <avue-input-tree style="width: 100%" 
                    node-key="id"
                    :props="defaultProps"
                    default-expand-all 
                    v-model="form.communityId" 
                    placeholder="请选择小区" 
                    type="select" 
                    @change="communityIdChange"
                    :dic="allPropertyList"
                >
                </avue-input-tree>
              <!-- <el-select
                v-model="form.communityId"
                filterable
                clearable
                collapse-tags
                @change="selectAll"
                style="margin-left: 20px"
                placeholder="请选择小区"
              >
                <el-option
                  v-for="item in allPropertyList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="扣款月份"
              prop="monthNo"
              :rules="[{ required: true, message: '请选择扣款月份', trigger: 'blur' }]"
            >
              <el-date-picker
                style="width: 100%" 
                @change="getBankCutPaymentTree"
                v-model="form.monthNo"
                :clearable="false"
                filterable
                type="month"
                placeholder="请选择扣款月份"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="划扣状态"
              prop="status"
              :rules="[{ required: false, message: '请选择划扣状态', trigger: 'blur' }]"
            >
              <el-select
                style="width: 100%"
                v-model="form.status"
                filterable
                clearable
                collapse-tags
                placeholder="请选择划扣状态"
              >
                <el-option
                  v-for="item in allStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="划扣批次"
              prop="bankCutPaymentId"
              :rules="[{ required: true, message: '请划扣批次', trigger: 'blur' }]"
            >
              <el-select
                style="width: 100%"
                v-model="form.bankCutPaymentId"
                filterable
                clearable
                placeholder="请选择划扣批次"
              >
                <el-option
                  v-for="item in bankCutPaymentList"
                  :key="item.id"
                  :label="item.drawLots"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="18">
            <el-form-item style="text-align:right;">
              <el-button type="primary" @click="onSubmit">立即查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params" :roomName="roomName" :name="name" />
    </basic-container>
  </div>
</template>

<script>
import WebReport from '@/components/web-report';
import { getTreeChildrenPowerNode } from '../../../api/v4ward/property/baseproperty';
import { getBankCutPaymentTree } from '../../../api/v4ward/bankcut/bankcutpayment';
import urlSettings from '@/config/url-settings.js';
import { getCommunityGroupList } from '../../../api/common';
    import _ from 'lodash';
export default {
  components: {
    WebReport,
  },
  data() {
    return {
        defaultProps:{
            children: 'children',
            label: 'title',
        value: 'id',
        },
      communityGroupList:[],
      url: '',
      form: {
        communityGroup:'',
        communityId: [],
        monthNo: '',
        status: '',
        bankCutPaymentId: '',
      },
      allPropertyList: [],
      allStatusList: [{
        value: '',
        label: '全部'
      }, {
        value: '全部成功',
        label: '全部成功'
      }, {
        value: '不成功',
        label: '不成功'
      }],
      bankCutPaymentList: [],
      oldOptions: [],
      params: {
        reportlet: urlSettings.VUE_APP_ENVIRONMENT + '/bankCutPaymentDetail.cpt',
      },
      dic: [],
    };
  },
  methods: {
        communityGroupChangeHandler(val){
          let this_ = this;
          this.allPropertyListCopy = [];
          this.form.communityId = [];
            this.initPropertyList((data)=>{
              // this.query.propertyId = data[0].id;
              this.form = _.cloneDeep(this_.form);
              // this.onLoad();
            });
        },
    selectAll(val) {
      this.form.communityId = val;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.params.communityId = this.form.communityId;
          this.params.bankCutPaymentId = this.form.bankCutPaymentId;
          this.params.status = this.form.status;
          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getBankCutPaymentTree(v) {
      this.form.bankCutPaymentId =""
      if (v) {
        let i = this.dayjs(v).format('YYYYMM');
        getBankCutPaymentTree({ billcycleNo: i }).then((data) => {
          this.bankCutPaymentList = data.data;
        });
      }
    },
    initPropertyList(cb) {
      var that = this;
      getTreeChildrenPowerNode({communityGroup:that.form.communityGroup}).then((data) => {
        this.allPropertyList = data.data;
this.form.communityId = this.allPropertyList[0].id;
        var reportUrl = urlSettings.BASE_REPORT_URL;
        this.url = reportUrl.split('?')[0];
        cb(data.data);
        // this.url =
        //   'http://rpt-test.pms1.cn/WebReport/ReportServer?reportlet=bankCutPaymentDetail.cpt';
        setTimeout(() => {
          this.$refs.WebReport.regroupUrl();
        }, 0);
      });
    },
  },


  created() {
    // this.initPropertyList();
    let this_ = this;
      getCommunityGroupList().then((res)=>{
        this.communityGroupList = res.data;
        this.form.communityGroup = res.data[0].dictKey;
          this.initPropertyList((data)=>{
              // this.form.communityId = data[0].id;
              this.form = _.cloneDeep(this_.form);
              // this.onLoad();
          });
      });
  },
};
</script>


<style scoped>
  .demo-form-inline .el-form-item__content{
    width: 100%;
  }</style>
